import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { toNumber } from 'lodash';
import { FundStrategy, useGetFundQuery, useGetFundReportQuery, useGetSectionWithQuestionsLazyQuery, useUpdateAssetAllocationTargetsMutation } from '~/types/types';
import { renderMarkdown } from '~/functions/markdown';
import { sfdrTreeviewNamesTargets } from '~/functions/sfdr';
import { getLocale } from '~/functions/translate';
export default /*#__PURE__*/_defineComponent({
  __name: 'SustainableObjectiveTreeTargets',
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(__props) {
    var route = useRoute();
    var locale = computed(function () {
      return getLocale();
    });
    var fundId = computed(function () {
      return toNumber(route.params.fund);
    });
    var referencePeriodId = computed(function () {
      return toNumber(route.query.referencePeriodId);
    });
    var _useGetFundQuery = useGetFundQuery({
        id: fundId
      }),
      fundResult = _useGetFundQuery.result;
    var fund = computed(function () {
      var _fundResult$value;
      return (_fundResult$value = fundResult.value) === null || _fundResult$value === void 0 ? void 0 : _fundResult$value.getFund;
    });
    var _useGetFundReportQuer = useGetFundReportQuery(computed(function () {
        return {
          input: {
            id: fundId.value,
            referencePeriodId: referencePeriodId.value
          }
        };
      }), computed(function () {
        var _route$query;
        return {
          enabled: !!((_route$query = route.query) !== null && _route$query !== void 0 && _route$query.referencePeriodId) && !!route.params.fund
        };
      })),
      calculatedSfdrReportResult = _useGetFundReportQuer.result,
      refetchFundReport = _useGetFundReportQuer.refetch;
    var calculatedSfdrReport = computed(function () {
      var _calculatedSfdrReport;
      return ((_calculatedSfdrReport = calculatedSfdrReportResult.value) === null || _calculatedSfdrReport === void 0 ? void 0 : _calculatedSfdrReport.getFundReport) || {
        nameOfFinancialMarketParticipant: '',
        legalEntityIdentifier: ''
      };
    });
    var getSectionsQuery = useGetSectionWithQuestionsLazyQuery({
      id: 0,
      fundId: 0,
      referencePeriodId: 0
    });
    var _useUpdateAssetAlloca = useUpdateAssetAllocationTargetsMutation(),
      updateAssetAllocationTargets = _useUpdateAssetAlloca.mutate;
    var triggerUpdateAssetAllocationTargets = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(key, val) {
        var value, input, sectionId, variables;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              value = parseFloat(val);
              input = {
                id: fundId.value,
                assetAllocationTargets: _defineProperty({}, key, isNaN(value) ? null : value)
              };
              _context.next = 4;
              return updateAssetAllocationTargets({
                input: input
              });
            case 4:
              refetchFundReport();
              sectionId = fund.value.fundStrategy === FundStrategy.Article_9 ? 1300 : 1200;
              variables = {
                id: sectionId,
                fundId: fundId.value,
                referencePeriodId: referencePeriodId.value
              };
              getSectionsQuery.load(null, variables) || getSectionsQuery.refetch(variables);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function triggerUpdateAssetAllocationTargets(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
    var environmentalDoesNotAddUp = computed(function () {
      var _fund$value, _fund$value$assetAllo, _fund$value2, _fund$value2$assetAll, _fund$value3, _fund$value3$assetAll;
      return ((_fund$value = fund.value) === null || _fund$value === void 0 ? void 0 : (_fund$value$assetAllo = _fund$value.assetAllocationTargets) === null || _fund$value$assetAllo === void 0 ? void 0 : _fund$value$assetAllo.percentEnvironmentalNotTaxonomyAligned) + ((_fund$value2 = fund.value) === null || _fund$value2 === void 0 ? void 0 : (_fund$value2$assetAll = _fund$value2.assetAllocationTargets) === null || _fund$value2$assetAll === void 0 ? void 0 : _fund$value2$assetAll.percentEnvironmentalTaxonomyAligned) !== ((_fund$value3 = fund.value) === null || _fund$value3 === void 0 ? void 0 : (_fund$value3$assetAll = _fund$value3.assetAllocationTargets) === null || _fund$value3$assetAll === void 0 ? void 0 : _fund$value3$assetAll.percentEnvironmental);
    });
    var sustainableDoesNotAddUp = computed(function () {
      var _fund$value4, _fund$value4$assetAll, _fund$value5, _fund$value5$assetAll, _fund$value6, _fund$value6$assetAll, _fund$value7, _fund$value7$assetAll;
      return ((_fund$value4 = fund.value) === null || _fund$value4 === void 0 ? void 0 : (_fund$value4$assetAll = _fund$value4.assetAllocationTargets) === null || _fund$value4$assetAll === void 0 ? void 0 : _fund$value4$assetAll.percentEnvironmentalNotTaxonomyAligned) + ((_fund$value5 = fund.value) === null || _fund$value5 === void 0 ? void 0 : (_fund$value5$assetAll = _fund$value5.assetAllocationTargets) === null || _fund$value5$assetAll === void 0 ? void 0 : _fund$value5$assetAll.percentEnvironmentalTaxonomyAligned) + ((_fund$value6 = fund.value) === null || _fund$value6 === void 0 ? void 0 : (_fund$value6$assetAll = _fund$value6.assetAllocationTargets) === null || _fund$value6$assetAll === void 0 ? void 0 : _fund$value6$assetAll.percentSocial) !== ((_fund$value7 = fund.value) === null || _fund$value7 === void 0 ? void 0 : (_fund$value7$assetAll = _fund$value7.assetAllocationTargets) === null || _fund$value7$assetAll === void 0 ? void 0 : _fund$value7$assetAll.percentSustainable);
    });
    var formTreeViews = computed(function () {
      var _fund$value8, _fund$value8$assetAll, _fund$value9, _fund$value9$assetAll, _fund$value10, _fund$value10$assetAl, _fund$value11, _fund$value11$assetAl, _fund$value12, _fund$value12$assetAl, _fund$value13, _fund$value13$assetAl, _fund$value14, _fund$value14$assetAl, _fund$value15, _fund$value15$assetAl, _fund$value16, _fund$value16$assetAl, _fund$value17, _fund$value17$assetAl, _fund$value18, _fund$value18$assetAl, _fund$value19, _fund$value19$assetAl;
      return {
        hasSustainableInvestmentObjective: [{
          id: 'percentEnvironmental',
          name: sfdrTreeviewNamesTargets.hasSustainableInvestmentWithEnvironmentalObjective[locale.value],
          dynamicValue: (_fund$value8 = fund.value) === null || _fund$value8 === void 0 ? void 0 : (_fund$value8$assetAll = _fund$value8.assetAllocationTargets) === null || _fund$value8$assetAll === void 0 ? void 0 : _fund$value8$assetAll.percentEnvironmental,
          disabled: !calculatedSfdrReport.value.isArticle9,
          selected: calculatedSfdrReport.value.hasEnvironmentalInvestments && calculatedSfdrReport.value.isArticle9,
          children: [{
            id: 'percentEnvironmentalTaxonomyAligned',
            name: sfdrTreeviewNamesTargets.hasEnvironmentalObjectiveEnvironmentallySustainableUnderEuTaxonomy[locale.value],
            dynamicValue: (_fund$value9 = fund.value) === null || _fund$value9 === void 0 ? void 0 : (_fund$value9$assetAll = _fund$value9.assetAllocationTargets) === null || _fund$value9$assetAll === void 0 ? void 0 : _fund$value9$assetAll.percentEnvironmentalTaxonomyAligned,
            disabled: !calculatedSfdrReport.value.isArticle9,
            selected: ((_fund$value10 = fund.value) === null || _fund$value10 === void 0 ? void 0 : (_fund$value10$assetAl = _fund$value10.assetAllocationTargets) === null || _fund$value10$assetAl === void 0 ? void 0 : _fund$value10$assetAl.percentEnvironmentalTaxonomyAligned) > 0 && calculatedSfdrReport.value.isArticle9
          }, {
            id: 'percentEnvironmentalNotTaxonomyAligned',
            name: sfdrTreeviewNamesTargets.hasEnvironmentalObjectiveNonEnvironmentallySustainableUnderEuTaxonomy[locale.value],
            dynamicValue: (_fund$value11 = fund.value) === null || _fund$value11 === void 0 ? void 0 : (_fund$value11$assetAl = _fund$value11.assetAllocationTargets) === null || _fund$value11$assetAl === void 0 ? void 0 : _fund$value11$assetAl.percentEnvironmentalNotTaxonomyAligned,
            disabled: !calculatedSfdrReport.value.isArticle9,
            selected: ((_fund$value12 = fund.value) === null || _fund$value12 === void 0 ? void 0 : (_fund$value12$assetAl = _fund$value12.assetAllocationTargets) === null || _fund$value12$assetAl === void 0 ? void 0 : _fund$value12$assetAl.percentEnvironmentalNotTaxonomyAligned) > 0 && calculatedSfdrReport.value.isArticle9
          }]
        }, {
          id: 'percentSocial',
          name: sfdrTreeviewNamesTargets.hasSustainableInvestmentWithSocialObjective[locale.value],
          dynamicValue: (_fund$value13 = fund.value) === null || _fund$value13 === void 0 ? void 0 : (_fund$value13$assetAl = _fund$value13.assetAllocationTargets) === null || _fund$value13$assetAl === void 0 ? void 0 : _fund$value13$assetAl.percentSocial,
          disabled: !calculatedSfdrReport.value.isArticle9,
          selected: calculatedSfdrReport.value.isArticle9 && calculatedSfdrReport.value.hasSocialObjective
        }],
        hasNoSustainableInvestmentObjective: [{
          id: 'percentSustainable',
          name: sfdrTreeviewNamesTargets.hasEsCharacteristics[locale.value],
          dynamicValue: (_fund$value14 = fund.value) === null || _fund$value14 === void 0 ? void 0 : (_fund$value14$assetAl = _fund$value14.assetAllocationTargets) === null || _fund$value14$assetAl === void 0 ? void 0 : _fund$value14$assetAl.percentSustainable,
          disabled: calculatedSfdrReport.value.isArticle9,
          selected: calculatedSfdrReport.value.isArticle8Plus,
          children: [{
            id: 'percentEnvironmentalTaxonomyAligned',
            name: sfdrTreeviewNamesTargets.hasEsCharacteristicsAndEnvironmentalObjectiveSustainableUnderEuTaxonomy[locale.value],
            dynamicValue: (_fund$value15 = fund.value) === null || _fund$value15 === void 0 ? void 0 : (_fund$value15$assetAl = _fund$value15.assetAllocationTargets) === null || _fund$value15$assetAl === void 0 ? void 0 : _fund$value15$assetAl.percentEnvironmentalTaxonomyAligned,
            disabled: calculatedSfdrReport.value.isArticle9,
            selected: ((_fund$value16 = fund.value) === null || _fund$value16 === void 0 ? void 0 : (_fund$value16$assetAl = _fund$value16.assetAllocationTargets) === null || _fund$value16$assetAl === void 0 ? void 0 : _fund$value16$assetAl.percentEnvironmentalTaxonomyAligned) > 0 && calculatedSfdrReport.value.isArticle8Plus
          }, {
            id: 'percentEnvironmentalNotTaxonomyAligned',
            name: sfdrTreeviewNamesTargets.hasEsCharacteristicsAndEnvironmentalObjectiveNonSustainableUnderEuTaxonomy[locale.value],
            disabled: calculatedSfdrReport.value.isArticle9,
            dynamicValue: (_fund$value17 = fund.value) === null || _fund$value17 === void 0 ? void 0 : (_fund$value17$assetAl = _fund$value17.assetAllocationTargets) === null || _fund$value17$assetAl === void 0 ? void 0 : _fund$value17$assetAl.percentEnvironmentalNotTaxonomyAligned,
            selected: ((_fund$value18 = fund.value) === null || _fund$value18 === void 0 ? void 0 : (_fund$value18$assetAl = _fund$value18.assetAllocationTargets) === null || _fund$value18$assetAl === void 0 ? void 0 : _fund$value18$assetAl.percentEnvironmentalNotTaxonomyAligned) > 0 && calculatedSfdrReport.value.isArticle8Plus
          }, {
            id: 'percentSocial',
            name: sfdrTreeviewNamesTargets.hasEsCharacteristicsAndSocialObjective[locale.value],
            dynamicValue: (_fund$value19 = fund.value) === null || _fund$value19 === void 0 ? void 0 : (_fund$value19$assetAl = _fund$value19.assetAllocationTargets) === null || _fund$value19$assetAl === void 0 ? void 0 : _fund$value19$assetAl.percentSocial,
            disabled: calculatedSfdrReport.value.isArticle9,
            selected: calculatedSfdrReport.value.isArticle8PlusWithSocialObjective
          }]
        }, {
          id: 'hasEsCharacteristicsWithoutSustainableInvestment',
          name: sfdrTreeviewNamesTargets.hasEsCharacteristicsWithoutSustainableInvestment[locale.value],
          disabled: calculatedSfdrReport.value.isArticle9,
          selected: calculatedSfdrReport.value.isArticle8
        }]
      };
    });
    return {
      __sfc: true,
      route: route,
      locale: locale,
      fundId: fundId,
      referencePeriodId: referencePeriodId,
      fundResult: fundResult,
      fund: fund,
      calculatedSfdrReportResult: calculatedSfdrReportResult,
      refetchFundReport: refetchFundReport,
      calculatedSfdrReport: calculatedSfdrReport,
      getSectionsQuery: getSectionsQuery,
      updateAssetAllocationTargets: updateAssetAllocationTargets,
      triggerUpdateAssetAllocationTargets: triggerUpdateAssetAllocationTargets,
      environmentalDoesNotAddUp: environmentalDoesNotAddUp,
      sustainableDoesNotAddUp: sustainableDoesNotAddUp,
      formTreeViews: formTreeViews,
      renderMarkdown: renderMarkdown
    };
  }
});